import r2wc from '@r2wc/react-to-web-component';
import { LandingPage} from '../components/Pages/LandingPage.tsx';
import { WebComponentWrapper } from './WebComponentWrapper.tsx';

export type LandingPageLink = {
	link_position: number,
	link_type: 'national_view' | 'state_view' | 'donor_gaps' | 'final_analysis',
	link_path: string,
	show_coming_soon_text: boolean,
	coming_soon_text: string
};

type Props = {
	year?: number,
	donor_gaps_description?: string,
	national_view_description?: string,
	state_view_description?: string,
	final_analysis_description?: string,
	landing_page_links?: LandingPageLink[],
	menu_links?: LandingPageLink[]
};
const WrappedPage = (
	{
		year,
		donor_gaps_description,
		national_view_description,
		state_view_description,
		final_analysis_description,
		landing_page_links,
		menu_links,
	}: Props) => {

	const donorGapsProps = landing_page_links?.find(link => link.link_type === 'donor_gaps')
	const stateViewProps = landing_page_links?.find(link => link.link_type === 'state_view')
	const nationalViewProps = landing_page_links?.find(link => link.link_type === 'national_view')
	const finalAnalysisProps = landing_page_links?.find(link => link.link_type === 'final_analysis')


	return (
		<WebComponentWrapper
			year={year}
			menuLinks={menu_links}
			landingPageLinks={landing_page_links}
		>
			<LandingPage
				// State Props
				stateViewChapterEnabled={stateViewProps !== undefined}
				stateViewDisabled={stateViewProps?.show_coming_soon_text}
				stateViewDisabledText={stateViewProps?.show_coming_soon_text ? stateViewProps?.coming_soon_text : undefined}
				stateViewDescription={state_view_description}
				stateViewPosition={stateViewProps?.link_position !== undefined ? stateViewProps?.link_position : 4}
				stateViewHref={stateViewProps?.link_path !== undefined ? stateViewProps?.link_path : undefined}
				// National Props
				nationalViewChapterEnabled={nationalViewProps !== undefined}
				nationalViewDisabled={nationalViewProps?.show_coming_soon_text}
				nationalViewDisabledText={nationalViewProps?.show_coming_soon_text ? nationalViewProps?.coming_soon_text : undefined}
				nationalViewDescription={national_view_description}
				nationalViewPosition={nationalViewProps?.link_position !== undefined ? nationalViewProps?.link_position : 4}
				nationalViewHref={nationalViewProps?.link_path !== undefined ? nationalViewProps?.link_path : undefined}
				// Donors Props
				donorsViewChapterEnabled={donorGapsProps !== undefined}
				donorsViewDisabled={donorGapsProps?.show_coming_soon_text}
				donorsViewDisabledText={donorGapsProps?.show_coming_soon_text ? donorGapsProps?.coming_soon_text : undefined}
				donorsViewDescription={donor_gaps_description}
				donorsViewPosition={donorGapsProps?.link_position !== undefined ? donorGapsProps?.link_position : 4}
				donorsViewHref={donorGapsProps?.link_path !== undefined ? donorGapsProps?.link_path : undefined}
				// Analysis Props
				analysisViewChapterEnabled={finalAnalysisProps !== undefined}
				analysisViewDisabled={finalAnalysisProps?.show_coming_soon_text}
				analysisViewDisabledText={finalAnalysisProps?.show_coming_soon_text ? finalAnalysisProps?.coming_soon_text : undefined}
				analysisViewDescription={final_analysis_description}
				analysisViewPosition={finalAnalysisProps?.link_position !== undefined ? finalAnalysisProps?.link_position : 4}
				analysisViewHref={finalAnalysisProps?.link_path !== undefined ? finalAnalysisProps?.link_path : undefined}
			/>
		</WebComponentWrapper>
	);
};

export const WebLandingPage = r2wc(WrappedPage, {
	props: {
		year: 'number',
		donor_gaps_description: 'string',
		state_view_description: 'string',
		national_view_description: 'string',
		landing_page_links: 'json',
		menu_links: 'json'
	}
});
